var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div id=\"opt-out-modal\" style=\"overflow: auto; width: auto; height: auto;\" class=\"popup popup-delete\"><div ng-style=\"{'background': theme_color}\" class=\"head\"><h2>Opt Out</h2></div><div class=\"container\"><p> \nAre you sure this property is <b>not </b>located in {{ report_criteria }}?</p><p>Ignoring the requirements of this legislation may expose you to legal action by the applicant.</p><div class=\"buttons\"><a href=\"#\" ng-click=\"$dismiss()\" class=\"cancel view-delete-button\">Cancel</a><a href=\"#\" ng-click=\"fulfill_requirement(profile, 'opt_out')\" class=\"delete delete-item-button\">Confirm</a><div class=\"cf\"></div></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/view/reports/optOutModal.jade
// module id = 944
// module chunks = 0